import {Record} from 'immutable';
import {schema} from 'normalizr';

const MessageTemplate = Record({
    id: null,
    name: null,
});

export const MessageTemplateSchema = new schema.Entity('messageTemplates');

export default MessageTemplate;
